import * as React from "react"
import Api, {APIs} from "../../../Api";
import DADataGrid from "../../digitalarz/data-grid/container/DataGrid";
import {Column, Row} from "../../digitalarz/data-grid/TypeDeclaration";
import PotentialProjectGrid from "../components/PotentialProjectGrid";
import {useSelector} from "react-redux";

interface IProps {
    isEAD: boolean
}

const PotentialProjects = (props: IProps) => {
    const params = useSelector((state: any) => state.dashboard)

    const [rows, setRows] = React.useState<Row[]>([])
    const [columns, setColumns] = React.useState<Column[]>([])
    React.useEffect(() => {
        if (rows.length === 0 && columns.length === 0) {
            const url: string = props.isEAD ? APIs.MoPD_POTENTIAL_PROJECTS_EAD : APIs.MoPD_POTENTIAL_PROJECTS
            Api.get(url, {
                "sro": params.sro, "sector": params.sector,
                donor: params.donor, "region": params.region
            }).then((payload) => {
                if (payload) {
                    setRows(payload.rows)
                    setColumns(payload.columns)
                }
            });
        }
    }, [])
    return (<React.Fragment>
        <PotentialProjectGrid key={"potential-project-grid"}
                              data={rows} columns={columns}
                              title={"Potential Projects"}
                              tableHeight={"auto"}
                              tableWidth={"auto"}></PotentialProjectGrid>
    </React.Fragment>)
}

export default PotentialProjects;
